const date = Shopify.Sections.countdownDate;
const limitDateFormat = new Date(date);
const currentDateFormat = new Date();

if (limitDateFormat - currentDateFormat > 0) {
  const daysElement = document.querySelector('.countdown__card--days .qty');
  const hoursElement = document.querySelector('.countdown__card--hours .qty');
  const minutesElement = document.querySelector('.countdown__card--minutes .qty');
  const secondsElement = document.querySelector('.countdown__card--seconds .qty');

  const intervalId = setInterval(updateCountdown, 1000);

  function updateCountdown() {
    const timeDifference = limitDateFormat - new Date();

    if (timeDifference <= 0) {
      clearInterval(intervalId);
      // Optionally, update the UI to indicate that the countdown has reached zero
      daysElement.textContent = '00';
      hoursElement.textContent = '00';
      minutesElement.textContent = '00';
      secondsElement.textContent = '00';
    } else {
      const seconds = Math.floor(timeDifference / 1000);
      const remainingDays = Math.floor(seconds / (24 * 60 * 60));
      const remainingHours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
      const remainingMinutes = Math.floor((seconds % (60 * 60)) / 60);
      const remainingSeconds = seconds % 60;

      daysElement.textContent = remainingDays.toString().padStart(2, '0');
      hoursElement.textContent = remainingHours.toString().padStart(2, '0');
      minutesElement.textContent = remainingMinutes.toString().padStart(2, '0');
      secondsElement.textContent = remainingSeconds.toString().padStart(2, '0');
    }
  }
} else {
  document.querySelector(".countdown-wrapper").style.display = "none";
}